import type { AccrualVault } from '@morpho-org/blue-sdk'

const maxBigInt = (a: bigint, b: bigint) => (a > b ? a : b)

// `AccrualVault.accrueInterest(ts)` throws (`InvalidInterestAccrual`) when `ts`
// is below any market's `lastUpdate`. A market's `lastUpdate` is a block
// timestamp, so accruing to the latest one is always safe.
export const getLatestMarketUpdate = (vaultData: AccrualVault) =>
  Array.from(vaultData.allocations.values()).reduce(
    (latest, { position }) => maxBigInt(latest, position.market.lastUpdate),
    0n
  )

/**
 * Choose accrued vs. raw vault data for a given block timestamp. Mirrors V2:
 * `accrueInterest` throws `InvalidInterestAccrual` below the freshest market
 * `lastUpdate`, so when the block clock sits behind it, return the data
 * unaccrued — never accrue backwards. Otherwise accrue to the block timestamp.
 */
export const resolveVaultDataAtBlock = (
  rawVaultData: AccrualVault,
  blockTimestamp: bigint
): AccrualVault =>
  blockTimestamp < getLatestMarketUpdate(rawVaultData)
    ? rawVaultData
    : rawVaultData.accrueInterest(blockTimestamp)
